/*
How to use:

Here's an example input field using this validator...
    <input
      type="file"
      id="profile_image_field"
      name="profile_image"
      style="display: none;"
      accept="image/*"
      hx-post="{% url 'profiles:view_profile' profile_user.username %}"
      hx-target="#profile-picture-section"
      hx-swap="outerHTML"
      hx-trigger="change"
      hx-encoding="multipart/form-data"
      hx-headers='{"X-CSRFToken": "{{ csrf_token }}"}'

      // you need the following attributes for this to work

      onchange="validateFileSize(event, 5, 'file_size_error_template')"
        ^ add validator
    >

    <div id="file_size_error_template" style="display: none;">
      File size must be less than 5MB.
    </div>

validateFileSize() props:
  event: Event
  maxMegs: number
  errorTemplateId: string
    ^ set the id of the error template
      this div should also have `style="display: none;"`
      The div will be copied, the id and style removed, and it will be pasted after the template.
  clearIfInvalid: boolean (default: true)
    ^ clear field if validation fails (optional, default: true)
      Usually leave this as `true`.
      That way if a user reselects the same file it re-runs the validation,
      because "" just changed to "thing.jpg" again.
      If this is `false` then the field will already be `thing.jpg` and will
      not re-run the validation.
*/

function validate(
  event: Event,
  maxMegs: number,
  errorTemplateId: string,
  clearIfInvalid: boolean = true,
): void {
  // set defaults
  let allow = false
  const maxBytes = maxMegs * 1024 * 1024

  // Get the input element
  const input = event.target as HTMLInputElement
  if (!input) {
    console.error('No input element found.')
    return
  }

  // Access the attached file
  const file = input.files?.[0]
  if (file && file.size <= maxBytes) {
    allow = true
  }

  if (!allow) {
    event.preventDefault() // Prevent the default POST behavior
    event.stopImmediatePropagation() // Stop HTMX or any other listener

    // Clone the error template
    const errorTemplate = document.getElementById(errorTemplateId)
    if (!errorTemplate) {
      console.error('No error template found.')
      return
    }
    const errorClone = errorTemplate.cloneNode(true) as HTMLElement

    // Remove the `id` and `display: none` from the cloned element
    errorClone.removeAttribute('id')
    errorClone.style.display = ''

    // Insert the cloned error message right after the template
    errorTemplate.after(errorClone)

    if (clearIfInvalid) {
      input.value = '' // Clear the input field
    }
  }
}

;(window as any).validateFileSize = validate
